import React, {useState, useEffect } from "react";
import Layout from "../Shared/Layout";

import axios from 'axios';
import TransactionClientTable from "./TransactionClientTable";


const TransactionsPage = () => {

	const [formData, setFormData] = useState({
		order_id: '',
		side: 'achat',
		creator_id: '',
		from_account_id: '',
		to_account_id: '',
		price: '',
		quantity: '',
		status: 'en attente',
	  });
	
	  const [orders, setOrders] = useState([]);
	  const [fromAccounts, setFromAccounts] = useState([]);
	  const [toAccounts, setToAccounts] = useState([]);
	
	  // Récupération des données depuis les APIs
	  useEffect(() => {
		const fetchOrders = async () => {
		  try {
			const response = await axios.get('/api/orders');
			setOrders(response.data);
		  } catch (error) {
			console.error('Erreur lors de la récupération des commandes:', error);
		  }
		};
	
		const fetchAccounts = async () => {
		  try {
			const response = await axios.get('/api/accounts');
			setFromAccounts(response.data);
			setToAccounts(response.data);
		  } catch (error) {
			console.error('Erreur lors de la récupération des comptes:', error);
		  }
		};
	
		fetchOrders();
		fetchAccounts();
	  }, []);
	
	  // Gestion des changements de formulaire
	  const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevState) => ({
		  ...prevState,
		  [name]: value,
		}));
	  };
	
	  // Gestion de la soumission du formulaire
	  const handleSubmit = (e) => {
		e.preventDefault();
		console.log('Transaction créée avec succès :', formData);
		alert('Transaction soumise avec succès!');
		// Appeler une API pour soumettre les données ici
	  };


	useEffect(() =>{
		var swiper = new Swiper('.ticketing-Swiper', {
			speed: 1500,	
			slidesPerView: 4,
			spaceBetween: 40,
			parallax: true,
			loop:false,
			autoplay:{
				Delay:1000,
			},
			breakpoints: {
				
				300: {
				slidesPerView: 1,
				spaceBetween: 30,
				},	
				576: {
				slidesPerView: 2,
				spaceBetween: 30,
				},
				991: {
				slidesPerView: 3,
				spaceBetween: 30,
				},
				1200: {
				slidesPerView: 3,
				spaceBetween: 30,
				},
				1600: {
				slidesPerView: 4,
				spaceBetween: 30,
				},
			},
		});
	}, []);

    return(
        <>
			<Layout>
				<div className="content-body default-height">
					<div className="container-fluid">
						<div className="page-titles">
							<nav style={{"--bs-breadcrumb-divider": "'>';"}} aria-label="breadcrumb">
								<ol className="breadcrumb">
									<li className="breadcrumb-item text-primary">Transaction</li>
								</ol>
							</nav>
						</div>
                        
						<TransactionClientTable />
						
					</div>
				</div>
			</Layout>



        </>
    )
}

export default TransactionsPage;

